/**
 * Which chrome a route gets.
 *
 * - The runner (/p/:code/run/:runId) is a focused flow: sticky action bar, no footer.
 * - Everything else gets the slim footer at the end of the content.
 */
const RUNNER = /^\/p\/[^/]+\/run\/[^/]+\/?$/;
const START = /^\/p\/[^/]+\/start\/?$/;

export function isRunnerRoute(pathname: string): boolean {
  return RUNNER.test(pathname);
}

export function isNoFooterRoute(pathname: string): boolean {
  return isRunnerRoute(pathname) || START.test(pathname);
}

/** Pages where the header's "Sign in" link would only distract. */
export function hidesSignInLink(pathname: string): boolean {
  return pathname.startsWith('/auth/') || isRunnerRoute(pathname);
}
